import { toast } from 'sonner';
import { sdk } from '@/services/sdk';

/** List envelope -> rows. Throws on failure so useFetch shows the error state. */
export function rows(r) {
  if (!r?.success) throw new Error(r?.message || 'Could not load data');
  return r.data ?? [];
}

/** List envelope -> { rows, total, hasMore } for paginated lists. */
export function paged(r) {
  if (!r?.success) throw new Error(r?.message || 'Could not load data');
  return { rows: r.data ?? [], total: r.total ?? 0, hasMore: !!r.hasMore };
}

/** Write envelope -> first committed record, or null after toasting the reason. */
export function committed(res, successMessage) {
  const messages = res?.messages ?? [];
  if (messages.length) {
    toast.error(messages[0], { description: messages.slice(1).join('\n') || undefined });
  }
  const data = res?.data ?? [];
  if (!data.length) {
    if (!messages.length) toast.error(res?.message || 'Nothing was saved');
    return null;
  }
  if (successMessage) toast.success(successMessage);
  const first = data[0];
  if (first && first.Id) return first;
  return first?.data ?? first ?? {};
}

export const idOf = (v) => (v && typeof v === 'object' ? v.Id : v) ?? null;

export const nameOf = (v) => (v && typeof v === 'object' ? v.Name : '') || '';

export const toArray = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === 'string' && v) return v.split(',').map((s) => s.trim()).filter(Boolean);
  return [];
};

const pad = (n) => String(n).padStart(2, '0');

/** UTC ISO -> value for <input type="datetime-local">. */
export function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** <input type="datetime-local"> value -> UTC ISO (or null when empty). */
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);

export function todayDate() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export const nowIso = () => new Date().toISOString();

/** A date-only value (YYYY-MM-DD) as local noon, so formatLocalDate never shows the day before. */
export const dayOf = (value) => (value ? `${String(value).slice(0, 10)}T12:00:00` : null);

export const fillTemplate = (text, vars) =>
  String(text ?? '').replace(/\{(\w+)\}/g, (match, key) => (vars[key] != null ? String(vars[key]) : match));

/** Best-effort audit trail for team actions. Never blocks the action it records. */
export async function logActivity(action, name, target = '', detail = '') {
  try {
    await sdk.table('activity_c').create({
      Name: name,
      action_c: action,
      target_c: target,
      detail_c: detail,
    });
  } catch {
    // the action itself already succeeded
  }
}

export const displayNameOf = (user) =>
  [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.emailAddress || 'Ghost Cable';
